// components/CurrencySymbol.tsx

interface CurrencySymbolProps {
  symbol: string;
  className?: string;
}

const CurrencySymbol: React.FC<CurrencySymbolProps> = ({
  symbol,
  className = "",
}) => {
  return <span className={className}>{symbol}</span>;
};

export default CurrencySymbol;
